module.exports = __webpack_public_path__ + "img/banner.4f347652.png";